import type { IconRootProps } from './Root'
import { IconRoot } from './Root'

export function ChevronIconSmall({ size = '1.5rem', ...props }: IconRootProps) {
  return (
    <IconRoot viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" size={size} {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.46967 9.96967C6.76256 9.67678 7.23744 9.67678 7.53033 9.96967L11.8232 14.2626C11.9209 14.3602 12.0791 14.3602 12.1768 14.2626L16.4697 9.96967C16.7626 9.67678 17.2374 9.67678 17.5303 9.96967C17.8232 10.2626 17.8232 10.7374 17.5303 11.0303L13.2374 15.3232C12.554 16.0066 11.446 16.0066 10.7626 15.3232L6.46967 11.0303C6.17678 10.7374 6.17678 10.2626 6.46967 9.96967Z"
      />
    </IconRoot>
  )
}
